import { useEditorStore } from '../../state/editorStore';
import { IconButton } from '../controls/PanelShell';

export function Toolbar() {
  const project = useEditorStore((s) => s.project);
  const renameProject = useEditorStore((s) => s.renameProject);
  const theme = useEditorStore((s) => s.theme);
  const setTheme = useEditorStore((s) => s.setTheme);
  const cutAtPlayhead = useEditorStore((s) => s.cutAtPlayhead);
  const rippleDeleteSelected = useEditorStore((s) => s.rippleDeleteSelected);
  const addCrossDissolveToSelected = useEditorStore((s) => s.addCrossDissolveToSelected);
  const snapEnabled = useEditorStore((s) => s.snapEnabled);
  const setSnapEnabled = useEditorStore((s) => s.setSnapEnabled);
  const setShowWindowManager = useEditorStore((s) => s.setShowWindowManager);
  const setInspectorTab = useEditorStore((s) => s.setInspectorTab);
  const connectedTabs = useEditorStore((s) => s.connectedTabs);
  const canUndo = useEditorStore((s) => s.canUndo);
  const canRedo = useEditorStore((s) => s.canRedo);
  const undo = useEditorStore((s) => s.undo);
  const redo = useEditorStore((s) => s.redo);
  const beginHistoryTransaction = useEditorStore((s) => s.beginHistoryTransaction);
  const endHistoryTransaction = useEditorStore((s) => s.endHistoryTransaction);

  return (
    <header className="grid h-12 shrink-0 grid-cols-[minmax(0,1fr)_auto_minmax(0,1fr)] items-center border-b border-hairline bg-panel px-3">
      <div className="flex min-w-0 items-center gap-1">
        <span className="mr-2 shrink-0 text-[15px] font-semibold tracking-tight text-text-high">
          CineGrid
        </span>
        <IconButton title="Undo (⌘Z)" onClick={undo} disabled={!canUndo}>
          Undo
        </IconButton>
        <IconButton title="Redo (⌘⇧Z)" onClick={redo} disabled={!canRedo}>
          Redo
        </IconButton>
        <IconButton title="Split at playhead (C)" onClick={cutAtPlayhead}>
          Split
        </IconButton>
        <IconButton title="Delete and close gap (⌫)" danger onClick={rippleDeleteSelected}>
          Delete
        </IconButton>
        <IconButton title="Add a dissolve between clips" onClick={addCrossDissolveToSelected}>
          Transition
        </IconButton>
        <IconButton title="Snap (S)" active={snapEnabled} onClick={() => setSnapEnabled(!snapEnabled)}>
          Snap
        </IconButton>
      </div>

      <input
        className="h-8 w-[min(280px,32vw)] rounded-lg border-0 bg-transparent px-3 text-center text-sm font-medium text-text-high outline-none transition-colors placeholder:text-text-low hover:bg-raised focus:bg-raised"
        value={project.name}
        onChange={(e) => renameProject(e.target.value)}
        onBlur={() => {
          renameProject(project.name.trim());
          endHistoryTransaction();
        }}
        onFocus={(e) => {
          beginHistoryTransaction();
          e.currentTarget.select();
        }}
        placeholder="Untitled Project"
        title="Click to name your project"
        aria-label="Project name"
      />

      <div className="flex items-center justify-end gap-1.5">
        <span className="timecode mr-1 hidden text-2xs text-text-low lg:inline">
          {project.settings.width}×{project.settings.height}
          {connectedTabs.length > 1 ? ` · ${connectedTabs.length} windows` : ''}
        </span>
        <IconButton title="Window Manager" onClick={() => setShowWindowManager(true)}>
          Layout
        </IconButton>
        <button
          type="button"
          title="Export / Render"
          onClick={() => setInspectorTab('export')}
          className="rounded-full bg-accent px-4 py-1.5 text-xs font-semibold text-white shadow-sm hover:brightness-110"
        >
          Export
        </button>
        <IconButton
          title="Toggle theme"
          onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')}
        >
          {theme === 'dark' ? 'Light' : 'Dark'}
        </IconButton>
      </div>
    </header>
  );
}
